import { render, staticRenderFns } from "./ProductsPanel.vue?vue&type=template&id=e2e29cf8&"
import script from "./ProductsPanel.vue?vue&type=script&lang=js&"
export * from "./ProductsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProductsPanel.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./ProductsPanel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports